<template lang="pug">
  .form__wr(v-if="form")
    form.form(@submit.prevent="submit", :class="{'form--hide': sent}")
      .form__title(v-if="form.title") {{form.title}}
      .form__subtitle Обязательные поля для заполнения*
      .form__row
        .form__input-wr
          input.form__input.form__input--name(type="text", v-model="name", placeholder="ФИО*", required, autocomplete="off")
      .form__row
        .form__input-wr
          input.form__input.form__input--phone(type="tel", v-model="phone", placeholder="+7(___)-___-__-__", v-mask="'+7(###)-###-##-##'", required, autocomplete="off")
        .form__input-wr
          input.form__input.form__input--email(type="email", v-model="email", placeholder="Email*", required, autocomplete="off")
      .form__row
        .form__input-wr
          textarea.form__textarea.form__textarea--message(v-model="message", placeholder="Текст сообщения*", required, autocomplete="off")
      .form__policy(v-if="form.btn") Нажимая кнопку «{{form.btn}}», Вы даёте согласие на&nbsp;
        router-link.form__policy-link(to="/politika-konfidencialnosti", target="_blank") обработку персональных данных
      button.form__btn(v-if="form.btn") {{form.btn}}
    .form__message(v-if="form.msg", v-html="form.msg", :class="{'form__message--show': sent}")
</template>

<script>
  // @ is an alias to /src
  import '@/components/common/form/form.styl';

  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';

  export default {
    name: 'Form',

    props: ['form'],

    mixins: [AjaxHelpersVue],

    data() {
      return {
        name: '',
        phone: '',
        email: '',
        message: '',
        sent: false
      }
    },

    components: {

    },

    created() {

    },

    methods: {
      submit() {
        let request = (this.form.type == 'reviews') ? 'Forms:sendReviewsForm' : 'Forms:sendMessageForm';

        let params = {
          name: this.name,
          phone: this.phone,
          email: this.email,
          message: this.message
        };

        this.req(`${request}`, {...params}, res => {
          if(this.checkProperty(res.status) && res.status == 'ok') {
            this.sent = true;
            dataLayer.push({'event': 'formsend'});
          }
        }, '', 'localPageRequest');
      }
    }
  }
</script>
